import { FBase } from "./FBase";
import { Paging } from "../paging";
import { isObject } from "@pineapplelab/util";
import firebase from "firebase/compat/app";
import { ProjectState } from "src/app/enums/projectState.enum";
import { Tag } from "./tag";

export class OurProject extends FBase {

    name: string = null;
    shortDescription: string = null;
    link: string = null;
    longDescription: string = null;
    date: firebase.firestore.Timestamp = null;
    endDate: firebase.firestore.Timestamp = null;
    image: string = null;
    state: ProjectState = ProjectState.IN_PROGRESS;
    logo: string = null;
    clientName: string = null;
    tag: Tag = null;

    __dateSelected: Date;
    __endDateSelected: Date;

    constructor(json?: { [key: string]: any }) {
        super();

        if(isObject(json)) {
        this.fromJson(json);
        }
    }

}
export namespace OurProject {

  export const PATH = 'ourProjects';

  export const PAGING = new Paging<OurProject>(<Paging.IPaging>{
    collection: PATH,
    orderOptions: [
      { field: 'name', label: 'name', placeholder: 'Filter by name', dataType: Paging.dataType.string }
    ],
  });

}



